// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"P_7","loader":"P_bS"};